import type { MouseEvent as ReactMouseEvent, Ref } from 'react';
import clsx from 'clsx';
import { Icon } from '@/components/Icon';
import { showContextMenu } from '@/shell/ContextMenu/ContextMenu';
import { startButtonMenu } from '@/shell/ContextMenu/menus';
import css from './Taskbar.module.css';

export interface StartButtonProps {
  /** True while the Start menu is showing; drives the pressed look. */
  open: boolean;
  onToggle: () => void;
  /** React 19 takes `ref` as an ordinary prop on function components. */
  ref?: Ref<HTMLButtonElement>;
}

export function StartButton({ open, onToggle, ref }: StartButtonProps) {
  return (
    <button
      ref={ref}
      type="button"
      className={clsx(css.start, open && css.startOpen)}
      aria-haspopup="menu"
      aria-expanded={open}
      onClick={onToggle}
      onContextMenu={(event: ReactMouseEvent<HTMLButtonElement>) =>
        showContextMenu(event, startButtonMenu())
      }
    >
      <Icon src="/assets/ui/windows-flag.svg" size={18} className={css.flag} />
      <span className={css.startLabel}>start</span>
    </button>
  );
}
